import 'es6-promise';
import * as CONSTANTS from '../modules/constants';
import { svgInject } from '../modules/svg-injection';
import { loginState } from '../modules/login-state';
import { nodeListToArray } from '../modules/nodelist-to-array';
import { AriaToggling } from '../modules/aria-toggling';
import { MobileMenu } from '../modules/mobile-menu';
import { SearchToggle } from '../modules/search-toggle';
import { Accordions } from '../../../Lib/Lib-Javascript/accordion/accordions';
import { Menu } from '../modules/menu';
import { ContractBlocks } from '../modules/contract-blocks';
import { VideoModal } from '../modules/video-modal';
import { SiteContainerHeight } from '../modules/site-container-height';
import { SpeakerInstructorBlock } from '../modules/speaker-instructor-block';
import { BlogTitleNormalization } from '../modules/blog-title-normalization';
import { FiltersToggle } from '../modules/Filters-toggle';
import { MembershipLanding } from '../modules/membership-landing';
import { ChannelMobileToggle } from '../modules/channel-detail';
import { EpiFormsSteps } from '../modules/epi-forms-steps';
import { PurchaseHistory } from '../modules/purchase-history';
import { InitializeSearchHeader, InitializeSearchPageSubmit } from '../modules/search';

(function () {
    CONSTANTS.GLOBAL_HTML.classList.remove('no-js');
    svgInject();

    new AriaToggling(nodeListToArray(document.querySelectorAll('#mNav .mnav-list-item > a')));

    // Dekstop Navigation 
    new Menu();

    // Mobile Navigation
    new MobileMenu(CONSTANTS.GLOBAL_BODY);

    // Site Container Height
    new SiteContainerHeight();

    // Search Toggle
    new SearchToggle(CONSTANTS.GLOBAL_BODY);

    // Accordion
    new Accordions();

    // Contract Blocks
    new ContractBlocks();

    // Handle mobile show more / less toggling on channel detail blocks
    new ChannelMobileToggle();

    // Video Modal
    var videoModal = new VideoModal();
    //(window as any).onYouTubeIframeAPIReady = videoModal.onYouTubeIframeAPIReady();

    // Speaker Instructor Block
    new SpeakerInstructorBlock();

    // Blog Title Font Sizing
    new BlogTitleNormalization();

    // Toggle for filters container on Blog Landing Page & Affiliate Directory Page
    new FiltersToggle(CONSTANTS.GLOBAL_BODY);

    // Membership Landing Page Toggles
    var isMemberApplicationPage = document.querySelector('*[data-member-application-landing="true"]')
    if (isMemberApplicationPage != null) {
        new MembershipLanding(CONSTANTS.GLOBAL_BODY);
    }

    //Filtering for printable purchase history
    new PurchaseHistory();

    new EpiFormsSteps();

    InitializeSearchHeader();
    InitializeSearchPageSubmit();
})();


// WEBPACK FOOTER //
// ./Static/javascript/common/global.ts